import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { AccountProvider, CartProvider, DialogProvider, SettingsProvider, ToastProvider } from './lib/store';
import { currentLang, LanguageProvider, loadArabic, useI18n } from './lib/i18n';

// Re-mount the app when the language changes so every screen redraws in the new language.
function LangKeyed({ children }) {
  const { lang } = useI18n();
  return <div key={lang} className="contents">{children}</div>;
}

// Installable app (PWA): register the service worker in production builds only,
// so it never caches files while developing.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => { navigator.serviceWorker.register('/sw.js').catch(() => {}); });
}

// Arabic visitors: fetch the Arabic texts first, so the page never flashes in English.
(currentLang() === 'ar' ? loadArabic().catch(() => {}) : Promise.resolve()).then(() => createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <LanguageProvider>
      <SettingsProvider>
        <AccountProvider>
          <CartProvider>
            <ToastProvider>
              <DialogProvider>
                <LangKeyed><App /></LangKeyed>
              </DialogProvider>
            </ToastProvider>
          </CartProvider>
        </AccountProvider>
      </SettingsProvider>
      </LanguageProvider>
    </BrowserRouter>
  </StrictMode>,
));
